// Core
import React from 'react';
import { useSelector } from 'react-redux';
// Components
import { GeckoRow, GECKO_CONSTS, GeckoTable, GeckoLabel } from 'ui';
import StatsLoader from 'routes/stats/components/StatsLoader';
import ProgressBar from 'react-bootstrap/ProgressBar';
import GeckoPagination from 'services/gecko-pagination';

// Other

const cols = [
  {
    key: 'name',
    name: 'Tag Name',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT,
    width: '45%',
    render: (name) => {
      if (name.startsWith('✨')) {
        return (
          <>
            <i className="far fa-sparkles gradient-icon"></i>
            {name.slice(1)}
          </>
        );
      } else {
        return name;
      }
    },
  },
  {
    key: 'count',
    name: 'Number of times used',
    class: 'tag-count',
    width: '45%',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_DEFAULT,
    render: (value, _key) => {
      const percentage = _key.percentage;
      return (
        <>
          <div className="tag-progress">
            <div className="tag-name">{value}</div>
            <ProgressBar now={percentage} />
          </div>
        </>
      );
    },
  },
  {
    key: 'general',
    name: 'General Sentiment',
    type: GECKO_CONSTS.TABLE_CELL_TYPE_CUSTOM,
    class: 'general',
    width: '10%',
    render: (value) => {
      const getType = (value) => {
        switch (value) {
          case 'Negative':
            return 'danger';
          case 'Positive':
            return 'success';
          default:
            return 'default';
        }
      };
      return (
        <GeckoLabel
          name={value}
          type={getType(value.replace(/[0-9%+\s]/g, ''))}
        />
      );
    },
  },
];

const ConversationsByTag = (props) => {
  const topTagsByConversation = useSelector(
    (state) => state.statsRoute.conversationTopTagsStats
  );

  const fetchingTopTagsStats = useSelector(
    (state) => state.statsRoute.fetchingTopTagsStats
  );

  const params = useSelector((state) => state.location.params);

  const maxCount = Math.max(...topTagsByConversation.map((item) => item.count));

  const topTagsWithPercentage = topTagsByConversation.map((item) => ({
    ...item,
    percentage: (item.count / maxCount) * 100,
  }));

  const [paginatedStats, pagination] = GeckoPagination.paginate({
    page: params.page,
    order_by: 'percentage',
    sort: 'DESC' || 'ASC',
  })(topTagsWithPercentage);

  const topTagsWithAiEmoji = paginatedStats.reduce((acc, item) => {
    const negative = Math.floor(parseFloat(item.negative));
    const neutral = Math.floor(parseFloat(item.neutral));
    const positive = Math.floor(parseFloat(item.positive));

    let general = '';
    let max = Math.max(negative, neutral, positive);

    if (max === negative) {
      general = `${Math.round(negative)}% Negative`;
    } else if (max === neutral) {
      general = `${Math.round(neutral)}% Neutral`;
    } else if (max === positive) {
      general = `${Math.round(positive)}% Positive`;
    }

    acc.push({
      name: `${item.ai_generated ? '✨ ' : ''}${item.name}`,
      count: parseInt(item.count),
      percentage: (item.count / maxCount) * 100,
      negative,
      neutral,
      positive,
      general,
    });

    return acc;
  }, []);

  const returnSixRows = topTagsWithAiEmoji.slice(0, 6);

  return (
    <div>
      <StatsLoader isLoading={fetchingTopTagsStats}>
        <GeckoRow>
          <div className="col">
            <GeckoTable
              cols={cols}
              rows={returnSixRows}
              hideHeaderRow={true}
              paginate={pagination}
            />
          </div>
        </GeckoRow>
      </StatsLoader>
    </div>
  );
};

export default ConversationsByTag;
